/** @type {import('tailwindcss').Config} */
export default {
  content: ['./public/**/*.html', './src/**/*.{js,jsx,ts,tsx,vue}'],
  theme: {
    extend: {
      screens: {
        md: '768px',
      },
      colors: {
        // Melissa Design System Base Palette
        'palette-primary-1': 'var(--palette-primary-1)',
        'palette-primary-2': 'var(--palette-primary-2)',
        'palette-primary-3': 'var(--palette-primary-3)',
        'palette-primary-4': 'var(--palette-primary-4)',
        'palette-primary-5': 'var(--palette-primary-5)',
        'palette-primary-6': 'var(--palette-primary-6)',
        'palette-primary-7': 'var(--palette-primary-7)',
        'palette-primary-8': 'var(--palette-primary-8)',
        'palette-primary-9': 'var(--palette-primary-9)',
        'palette-secondary-1': 'var(--palette-secondary-1)',
        'palette-secondary-2': 'var(--palette-secondary-2)',
        'palette-secondary-3': 'var(--palette-secondary-3)',
        'palette-secondary-4': 'var(--palette-secondary-4)',
        'palette-secondary-5': 'var(--palette-secondary-5)',
        'palette-secondary-6': 'var(--palette-secondary-6)',
        'palette-secondary-7': 'var(--palette-secondary-7)',
        'palette-secondary-8': 'var(--palette-secondary-8)',
        'palette-secondary-9': 'var(--palette-secondary-9)',
        'palette-neutral-1': 'var(--palette-neutral-1)',
        'palette-neutral-2': 'var(--palette-neutral-2)',
        'palette-neutral-3': 'var(--palette-neutral-3)',
        'palette-neutral-4': 'var(--palette-neutral-4)',
        'palette-neutral-5': 'var(--palette-neutral-5)',
        'palette-neutral-6': 'var(--palette-neutral-6)',
        'palette-neutral-7': 'var(--palette-neutral-7)',
        'palette-neutral-8': 'var(--palette-neutral-8)',
        'palette-neutral-9': 'var(--palette-neutral-9)',
        'palette-error-1': 'var(--palette-error-1)',
        'palette-error-2': 'var(--palette-error-2)',
        'palette-error-3': 'var(--palette-error-3)',
        'palette-error-4': 'var(--palette-error-4)',
        'palette-error-5': 'var(--palette-error-5)',
        'palette-error-6': 'var(--palette-error-6)',
        'palette-error-7': 'var(--palette-error-7)',
        'palette-error-8': 'var(--palette-error-8)',
        'palette-error-9': 'var(--palette-error-9)',
        'palette-success-1': 'var(--palette-success-1)',
        'palette-success-2': 'var(--palette-success-2)',
        'palette-success-3': 'var(--palette-success-3)',
        'palette-success-4': 'var(--palette-success-4)',
        'palette-success-5': 'var(--palette-success-5)',
        'palette-success-6': 'var(--palette-success-6)',
        'palette-success-7': 'var(--palette-success-7)',
        'palette-success-8': 'var(--palette-success-8)',
        'palette-success-9': 'var(--palette-success-9)',
        'palette-warning-1': 'var(--palette-warning-1)',
        'palette-warning-2': 'var(--palette-warning-2)',
        'palette-warning-3': 'var(--palette-warning-3)',
        'palette-warning-4': 'var(--palette-warning-4)',
        'palette-warning-5': 'var(--palette-warning-5)',
        'palette-warning-6': 'var(--palette-warning-6)',
        'palette-warning-7': 'var(--palette-warning-7)',
        'palette-warning-8': 'var(--palette-warning-8)',
        'palette-warning-9': 'var(--palette-warning-9)',
        //agent variables
        'agent-brand': 'var(--color-agent-brand)',
        'agent-desktop-drawer-background-color':
          'var(--agent-desktop-drawer-background-color)',
        'agent-desktop-drawer-border-left-color':
          'var(--agent-desktop-drawer-border-left-color)',
        'agent-desktop-drawer-border-right-color':
          'var(--agent-desktop-drawer-border-right-color)',
        'close-button-line-color': 'var(--close-button-line-color)',
        'close-button-line-color-hover': 'var(--close-button-line-color-hover)',
        'close-button-background-color': 'var(--close-button-background-color)',
        'close-button-background-color-hover':
          'var(--close-button-background-color-hover)',
        'close-button-line-width': 'var(--close-button-line-width)',
        'bubble-0': 'var(--icon-color-0)',
        'bubble-1': 'var(--icon-color-1)',
        'bubble-2': 'var(--icon-color-2)',
        'bubble-3': 'var(--icon-color-3)',
        'bubble-4': 'var(--icon-color-4)',
        'hero-font-color': 'var(--hero-font-color)',
        'followup-background-color': 'var(--followup-background-color)',
        'followup-font-color': 'var(--followup-font-color)',
        'followup-placeholder-color': 'var(--followup-placeholder-color)',
        'return-button-background-color':
          'var(--return-button-background-color)',
        'return-button-background-color-hover':
          'var(--return-button-background-color-hover)',
        'return-button-background-color-active':
          'var(--return-button-background-color-active)',
        'return-button-icon-color': 'var(--return-button-icon-color)',
        'return-button-icon-color-hover':
          'var(--return-button-icon-color-hover)',
        'return-button-icon-color-active':
          'var(--return-button-icon-color-active)',
        'user-message-background-color': 'var(--user-message-background-color)',
        'user-message-border-color': 'var(--user-message-border-color)',
        'user-message-font-color': 'var(--user-message-font-color)',
        'melissa-message-background-color':
          'var(--melissa-message-background-color)',
        'melissa-message-border-color': 'var(--melissa-message-border-color)',
        'melissa-message-font-color': 'var(--melissa-message-font-color)',
        'parameter-card-border-color': 'var(--parameter-card-border-color)',
        'parameter-card-border-color-hover':
          'var(--parameter-card-border-color-hover)',
        'parameter-card-border-color-active':
          'var(--parameter-card-border-color-active)',
        'parameter-card-font-color': 'var(--parameter-card-font-color)',
        'parameter-card-font-color-hover':
          'var(--parameter-card-font-color-hover)',
        'parameter-card-font-color-active':
          'var(--parameter-card-font-color-active)',
        'outline-parameter-card-border-color':
          'var(--outline-parameter-card-border-color)',
        'outline-parameter-card-border-color-hover':
          'var(--outline-parameter-card-border-color-hover)',
        'outline-parameter-card-border-color-active':
          'var(--outline-parameter-card-border-color-active)',
        'outline-parameter-card-font-color':
          'var(--outline-parameter-card-font-color)',
        'outline-parameter-card-font-color-hover':
          'var(--outline-parameter-card-font-color-hover)',
        'outline-parameter-card-font-color-active':
          'var(--outline-parameter-card-font-color-active)',
        'total-parameter-card-border-color':
          'var(--total-parameter-card-border-color)',
        'total-parameter-card-border-color-hover':
          'var(--total-parameter-card-border-color-hover)',
        'total-parameter-card-border-color-active':
          'var(--total-parameter-card-border-color-active)',
        'total-parameter-card-font-color':
          'var(--total-parameter-card-font-color)',
        'total-parameter-card-font-color-hover':
          'var(--total-parameter-card-font-color-hover)',
        'total-parameter-card-font-color-active':
          'var(--total-parameter-card-font-color-active)',
        'current-selection-background-color':
          'var(--current-selection-background-color)',
        'current-selection-background-color-hover':
          'var(--current-selection-background-color-hover)',
        'current-selection-background-color-active':
          'var(--current-selection-background-color-active)',
        'current-selection-border-color':
          'var(--current-selection-border-color)',
        'current-selection-border-color-hover':
          'var(--current-selection-border-color-hover)',
        'current-selection-border-color-active':
          'var(--current-selection-border-color-active)',
        'current-selection-font-color': 'var(--current-selection-font-color)',
        'current-selection-font-color-hover':
          'var(--current-selection-font-color-hover)',
        'current-selection-font-color-active':
          'var(--current-selection-font-color-active)',
        'drawer-card-background-color': 'var(--drawer-card-background-color)',
        'drawer-card-title-font-color': 'var(--drawer-card-title-font-color)',
        'drawer-card-text-font-color': 'var(--drawer-card-text-font-color)',
        'drawer-card-label-font-color': 'var(--drawer-card-label-font-color)',
        'drawer-card-input-border-color':
          'var(--drawer-card-input-border-color)',
        'drawer-card-input-border-color-hover':
          'var(--drawer-card-input-border-color-hover)',
        'drawer-card-input-border-color-active':
          'var(--drawer-card-input-border-color-active)',
        'drawer-card-input-background-color':
          'var(--drawer-card-input-background-color)',
        'drawer-card-input-background-color-hover':
          'var(--drawer-card-input-background-color-hover)',
        'drawer-card-input-background-color-active':
          'var(--drawer-card-input-background-color-active)',
        'drawer-card-input-text-color': 'var(--drawer-card-input-text-color)',
        'drawer-card-input-text-color-hover':
          'var(--drawer-card-input-text-color-hover)',
        'drawer-card-input-text-color-active':
          'var(--drawer-card-input-text-color-active)',
        'drawer-card-input-placeholder-color':
          'var(--drawer-card-input-placeholder-color)',
        // Global utility tokens
        light: 'var(--color-light)',
        dark: 'var(--color-dark)',
        medium: 'var(--color-medium)',
        'medium-light': 'var(--color-medium-light)',
        brand: 'var(--color-brand)',
        'brand-darken': 'var(--color-brand-darken)',
        'brand-lighten': 'var(--color-brand-lighten)',
        secondary: 'var(--color-secondary)',
        border: 'var(--color-border)',
        success: 'var(--color-success)',
        warning: 'var(--color-warning)',
        error: 'var(--color-error)',
        'dark-error': 'var(--color-dark-error)',
        'btn-disabled': 'var(--color-btn-disabled)',
        shadow: 'var(--color-shadow)',
        title: 'var(--color-title)',
        'small-titles': 'var(--color-small-titles)',
        text: 'var(--color-text)',
        'bg-main': 'var(--color-bg-main)',
        'bg-header': 'var(--color-bg-header)',
        'bg-footer': 'var(--color-bg-footer)',
        'bg-footer-hover': 'var(--color-bg-footer-hover)',
        'border-footer': 'var(--color-border-footer)',
        'border-footer-hover': 'var(--color-border-footer-hover)',
        'header-menu-icons': 'var(--color-header-menu-icons)',
        'header-menu-icons-hover': 'var(--color-header-menu-icons-hover)',
        'header-menu-icons-bg': 'var(--color-header-menu-icons-bg)',
        'header-menu-icons-bg-hover': 'var(--color-header-menu-icons-bg-hover)',
        'header-menu-border': 'var(--color-header-menu-border)',
        'header-menu-border-hover': 'var(--color-header-menu-border-hover)',
        'header-icons': 'var(--color-header-icons)',
        'header-icons-hover': 'var(--color-header-icons-hover)',
        'nav-icons-border': 'var(--color-nav-icons-border)',
        'nav-icons-border-hover': 'var(--color-nav-icons-border-hover)',
        'nav-icons-bg': 'var(--color-nav-icons-bg)',
        'nav-icons-bg-hover': 'var(--color-nav-icons-bg-hover)',
        burger: 'var(--color-burger)',
        'burger-bg': 'var(--color-burger-bg)',
        'burger-border': 'var(--color-burger-border)',
        'burger-hover': 'var(--color-burger-hover)',
        'burger-bg-hover': 'var(--color-burger-bg-hover)',
        'burger-border-hover': 'var(--color-burger-border-hover)',
        'bg-card': 'var(--color-bg-card)',
        'bg-card-hover': 'var(--color-bg-card-hover)',
        'border-card': 'var(--color-border-card)',
        'border-card-hover': 'var(--color-border-card-hover)',
        'card-title': 'var(--color-card-title)',
        'card-title-hover': 'var(--color-card-title-hover)',
        'card-sub-title': 'var(--color-card-sub-title)',
        'card-sub-title-hover': 'var(--color-card-sub-title-hover)',
        'card-arrow': 'var(--color-card-arrow)',
        'card-arrow-hover': 'var(--color-card-arrow-hover)',
        'card-bg-arrow': 'var(--color-card-bg-arrow)',
        'card-bg-arrow-hover': 'var(--color-card-bg-arrow-hover)',
        'bg-card-main': 'var(--color-bg-card-main)',
        'border-card-main': 'var(--color-border-card-main)',
        'bg-card-secondary': 'var(--color-bg-card-secondary)',
        'border-card-secondary': 'var(--color-border-card-secondary)',
        'cal-arrows': 'var(--color-cal-arrows)',
        'cal-arrows-hover': 'var(--color-cal-arrows-hover)',
        'background-cal-arrows': 'var(--background-cal-arrows)',
        'background-cal-arrows-hover': 'var(--background-cal-arrows-hover)',
        'cal-select': 'var(--color-cal-select)',
        'cal-select-text': 'var(--color-cal-select-text)',
        'cal-select-betwn': 'var(--color-cal-select-betwn)',
        'cal-select-betwn-text': 'var(--color-cal-select-betwn-text)',
        'cal-select-betwn-prices-text':
          'var(--color-cal-select-betwn-prices-text)',
        'cal-bg': 'var(--color-cal-bg)',
        'border-cal-days': 'var(--color-border-cal-days)',
        btn: 'var(--color-btn)',
        'btn-border': 'var(--color-btn-border)',
        'text-btn': 'var(--color-text-btn)',
        'btn-hover': 'var(--color-btn-hover)',
        'btn-border-hover': 'var(--color-btn-border-hover)',
        'text-btn-hover': 'var(--color-text-btn-hover)',
        'alternative-btn': 'var(--color-alternative-btn)',
        'alternative-btn-border': 'var(--color-alternative-btn-border)',
        'text-alternative-btn': 'var(--color-text-alternative-btn)',
        'alternative-btn-hover': 'var(--color-alternative-btn-hover)',
        'alternative-btn-border-hover':
          'var(--color-alternative-btn-border-hover)',
        'text-alternative-btn-hover': 'var(--color-text-alternative-btn-hover)',
        'secondary-btn': 'var(--color-secondary-btn)',
        'secondary-btn-border': 'var(--color-secondary-btn-border)',
        'secondary-text-btn': 'var(--color-secondary-text-btn)',
        'secondary-btn-hover': 'var(--color-secondary-btn-hover)',
        'secondary-btn-border-hover': 'var(--color-secondary-btn-border-hover)',
        'secondary-text-btn-hover': 'var(--color-secondary-text-btn-hover)',
        'text-btn-back': 'var(--color-text-btn-back)',
        'border-btn-back': 'var(--color-border-btn-back)',
        'bg-btn-back': 'var(--color-bg-btn-back)',
        'text-btn-back-hover': 'var(--color-text-btn-back-hover)',
        'border-btn-back-hover': 'var(--color-border-btn-back-hover)',
        'bg-btn-back-hover': 'var(--color-bg-btn-back-hover)',
        'bg-restrictions': 'var(--color-bg-restrictions)',
        'outline-restrictions': 'var(--color-border-restrictions)',
        'bg-btn-restrictions': 'var(--color-bg-btn-restrictions)',
        'bg-btn-restrictions-text': 'var(--color-bg-btn-restrictions-text)',
        'bg-btn-restrictions-hover': 'var(--color-bg-btn-restrictions-hover)',
        'bg-btn-restrictions-text-hover':
          'var(--color-bg-btn-restrictions-text-hover)',
        'bg-btn-promo': 'var(--color-bg-btn-promo)',
        'border-btn-promo': 'var(--color-border-btn-promo)',
        'border-btn-promo-text': 'var(--color-border-btn-promo-text)',
        'bg-btn-promo-hover': 'var(--color-bg-btn-promo-hover)',
        'border-btn-promo-hover': 'var(--color-border-btn-promo-hover)',
        'border-btn-promo-text-hover':
          'var(--color-border-btn-promo-text-hover)',
        'bg-pop': 'var(--color-bg-pop)',
        'text-pop-title': 'var(--color-text-pop-title)',
        'border-pop': 'var(--color-border-pop)',
        'info-signal': 'var(--color-info-signal)',
        'info-icon': 'var(--color-info-icon)',
        'text-tag': 'var(--color-text-tag)',
        'bg-tag': 'var(--color-bg-tag)',
        'amenities-icon': 'var(--color-amenities-icon)',
        'amenities-text': 'var(--color-amenities-text)',
        'bg-amenities-icon': 'var(--color-bg-amenities-icon)',
        'bg-tag-discount': 'var(--color-bg-tag-discount)',
        'text-tag-discount': 'var(--color-text-tag-discount)',
        rezlock: 'var(--color-rezlock)',
        'btn-rezlock': 'var(--color-btn-rezlock)',
        'btn-text-rezlock': 'var(--color-btn-text-rezlock)',
        'btn-rezlock-hover': 'var(--color-btn-rezlock-hover)',
        'btn-text-rezlock-hover': 'var(--color-btn-text-rezlock-hover)',
        'skeleton-shimmer': 'var(--color-skeleton-shimmer)',
        overlay: 'var(--color-overlay)',
        'error-soft': 'var(--color-error-soft)',
        'bar-unavailable-selected': 'var(--color-bar-unavailable-selected)',
        'shopping-activation-text': 'var(--color-shopping-activation-text)',
        'shopping-activation-bg-success':
          'var(--color-shopping-activation-bg-success)',
        'shopping-activation-bg-hover':
          'var(--color-shopping-activation-bg-hover)',
        'shopping-activation-bg-blue':
          'var(--color-shopping-activation-bg-blue)',
        'shopping-activation-bg-dark':
          'var(--color-shopping-activation-bg-dark)',
        'shopping-activation-bg-yellow':
          'var(--color-shopping-activation-bg-yellow)',
        'shopping-activation-close-bg':
          'var(--color-shopping-activation-close-bg)',
        'shopping-activation-close-text':
          'var(--color-shopping-activation-close-text)',
        'shopping-activation-close-bg-dark':
          'var(--color-shopping-activation-close-bg-dark)',
        'shopping-activation-close-text-dark':
          'var(--color-shopping-activation-close-text-dark)',
        'shopping-activation-close-bg-hover':
          'var(--color-shopping-activation-close-bg-hover)',
        'shopping-activation-close-text-hover':
          'var(--color-shopping-activation-close-text-hover)',
        'meal-plan-notice-bg': 'var(--color-meal-plan-notice-bg)',
        'meal-plan-notice-border': 'var(--color-meal-plan-notice-border)',
        'meal-plan-notice-text': 'var(--color-meal-plan-notice-text)',
        'custom-select-bg': 'var(--color-custom-select-bg)',
        'timepicker-indicator-bg': 'var(--color-timepicker-indicator-bg)',
        'timepicker-indicator-text': 'var(--color-timepicker-indicator-text)',
        'menu-areaBackground_color': 'var(--menu-areaBackground_color)',
        'menu-areaText-color': 'var(--menu-areaText-color)',
        'menu-areaText-colorHover': 'var(--menu-areaText-colorHover)',
        'menu-areaText-colorActive': 'var(--menu-areaText-colorActive)',
      },
      fontFamily: {
        cal: 'var(--font-cal)',
        'cal-prices': 'var(--font-cal-prices)',
        'card-sub-title': 'var(--font-card-sub-title)',
        'card-title': 'var(--font-card-title)',
        'text-pop-title': 'var(--font-text-pop-title)',
        'primary-button': 'var(--font-primary-button)',
        'hero-font': 'var(--hero-font)',
        'agent-primary': 'var(--agent-font-family-primary)',
        'agent-secondary': 'var(--agent-font-family-secondary)',
        'user-message-font-family': 'var(--user-message-font-family)',
        'melissa-message-font-family': 'var(--melissa-message-font-family)',
        'parameter-card-title-font-family':
          'var(--parameter-card-title-font-family)',
        'total-parameter-card-font-family':
          'var(--total-parameter-card-font-family)',
        'current-selection-font-family': 'var(--current-selection-font-family)',
        'drawer-card-title-font-family': 'var(--drawer-card-title-font-family)',
        'drawer-card-text-font-family': 'var(--drawer-card-text-font-family)',
        'drawer-card-label-font-family': 'var(--drawer-card-label-font-family)',
        'drawer-card-input-text-font-family':
          'var(--drawer-card-input-text-font-family)',
        'drawer-card-input-placeholder-font-family':
          'var(--drawer-card-input-placeholder-font-family)',
      },
      fontSize: {
        xs: ['calc(0.75rem * var(--font-scale, 1))', { lineHeight: '1.3em' }],
        sm: ['calc(0.875rem * var(--font-scale, 1))', { lineHeight: '1.5em' }],
        base: ['calc(1rem * var(--font-scale, 1))', { lineHeight: '1.5em' }],
        lg: ['calc(1.125rem * var(--font-scale, 1))', { lineHeight: '1.5em' }],
        xl: ['calc(1.25rem * var(--font-scale, 1))', { lineHeight: '1.75em' }],
        '2xl': ['calc(1.5rem * var(--font-scale, 1))', { lineHeight: '2em' }],
        '3xl': ['calc(1.875rem * var(--font-scale, 1))', { lineHeight: '2em' }],
        '4xl': ['calc(2.25rem * var(--font-scale, 1))', { lineHeight: '2em' }],
        'menu-areaText-size': 'var(--menu-areaText-size)',
        'hero-font-size': 'var(--hero-font-size)',
        'followup-font-size': 'var(--followup-font-size)',
        'user-message-font-size': 'var(--user-message-font-size)',
        'melissa-message-font-size': 'var(--melissa-message-font-size)',
        'parameter-card-title-font-size':
          'var(--parameter-card-title-font-size)',
        'parameter-card-font-size': 'var(--parameter-card-font-size)',
        'parameter-card-font-size-md': 'var(--parameter-card-font-size-md)',
        'outline-parameter-card-font-size':
          'var(--outline-parameter-card-font-size)',
        'outline-parameter-card-price-font-size':
          'var(--outline-parameter-card-price-font-size)',
        'total-parameter-card-font-size':
          'var(--total-parameter-card-font-size)',
        'total-parameter-card-price-font-size':
          'var(--total-parameter-card-price-font-size)',
        'current-selection-font-size': 'var(--current-selection-font-size)',
        'drawer-card-title-font-size': 'var(--drawer-card-title-font-size)',
        'drawer-card-text-font-size': 'var(--drawer-card-text-font-size)',
        'drawer-card-label-font-size': 'var(--drawer-card-label-font-size)',
        'drawer-card-input-text-font-size':
          'var(--drawer-card-input-text-font-size)',
        'drawer-card-input-placeholder-font-size':
          'var(--drawer-card-input-placeholder-font-size)',
      },
      fontWeight: {
        'hero-font-weight': 'var(--hero-font-weight)',
        'followup-font-weight': 'var(--followup-font-weight)',
        'user-message-font-weight': 'var(--user-message-font-weight)',
        'melissa-message-font-weight': 'var(--melissa-message-font-weight)',
        'parameter-card-font-weight': 'var(--parameter-card-font-weight)',
        'outline-parameter-card-font-weight':
          'var(--outline-parameter-card-font-weight)',
        'outline-parameter-card-price-font-weight':
          'var(--outline-parameter-card-price-font-weight)',
        'total-parameter-card-font-weight':
          'var(--total-parameter-card-font-weight)',
        'total-parameter-card-price-font-weight':
          'var(--total-parameter-card-price-font-weight)',
        'current-selection-font-weight': 'var(--current-selection-font-weight)',
        'drawer-card-title-font-weight': 'var(--drawer-card-title-font-weight)',
        'drawer-card-text-font-weight': 'var(--drawer-card-text-font-weight)',
        'drawer-card-label-font-weight': 'var(--drawer-card-label-font-weight)',
        'drawer-card-input-text-font-weight':
          'var(--drawer-card-input-text-font-weight)',
        'drawer-card-input-placeholder-font-weight':
          'var(--drawer-card-input-placeholder-font-weight)',
      },
      borderRadius: {
        'gc-sm': 'var(--border-radius-sm)',
        'gc-md': 'var(--border-radius-md)',
        'gc-lg': 'var(--border-radius-lg)',
        cut: 'var(--border-radius-cut)',
        'radius-arrow': 'var(--border-radius-arrow)',
        'radius-card': 'var(--border-radius-card)',
        'drawer-card-input-border-radius':
          'var(--drawer-card-input-border-radius)',
      },
      boxShadow: {
        'agent-sm': 'var(--agent-shadow-sm)',
        'agent-md': 'var(--agent-shadow-md)',
        'agent-lg': 'var(--agent-shadow-lg)',
        'agent-neumorphic-sm': 'var(--agent-neumorphic-shadow-small)',
        'agent-button-primary': 'var(--agent-button-primary-shadow)',
      },
      transitionTimingFunction: {
        'agent-linear': 'var(--agent-ease-linear)',
        'agent-in': 'var(--agent-ease-in)',
        'agent-out': 'var(--agent-ease-out)',
        'agent-in-out': 'var(--agent-ease-in-out)',
      },
      margin: {
        '10p': '10%',
      },
      outlineWidth: {
        'border-card': 'var(--border-card)',
        'border-card-main': 'var(--border-card-main)',
      },
      borderWidth: {
        'border-nav-icons': 'var(--border-nav-icons)',
        'border-header-menu-icons': 'var(--border-header-menu-icons)',
        'border-burger': 'var(--border-burger)',
        'border-card-main': 'var(--border-card-main)',
        'border-card-arrow': 'var(--border-card-arrow)',
        'border-card-secondary': 'var(--border-card-secondary)',
        'border-footer': 'var(--border-footer)',
        'user-message-border': 'var(--user-message-border-width)',
        'user-message-border-width': 'var(--user-message-border-width)',
        'melissa-message-border-width': 'var(--melissa-message-border-width)',
        'parameter-card-border-width': 'var(--parameter-card-border-width)',
        'outline-parameter-card-border-width':
          'var(--outline-parameter-card-border-width)',
        'agent-desktop-drawer-border-left-width':
          'var(--agent-desktop-drawer-border-left-width)',
        'agent-desktop-drawer-border-right-width':
          'var(--agent-desktop-drawer-border-right-width)',
        'drawer-card-input-border-width':
          'var(--drawer-card-input-border-width)',
      },
    },
  },
  plugins: [],
};
